import AvatarWithTextItems from './AvatarWithTextItems';

export default AvatarWithTextItems;
